import axios from 'axios';

const apiIP = {
    get: async function () {
        let ip = await axios.get('https://api.ipify.org/?format=json').then(resp => resp.data.ip);
        return ip
    }
}

export default apiIP;